import { displayGroups } from '@ui';

import { TouchPointHelper } from '../../../helpers/touchPointHelper';

export const _root = {
	prismName: '_root',
	template: {
		templateName: '_rootTemplate',
		displayGroups: [TouchPointHelper.createDisplayGroup(displayGroups.pageContainer, [], [])],
	},
};
